export const alwaysPublicRoutes = [
    "/session-expired",
    "/sso/:usersession/:temptoken"
]